import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
  // Override the stacking layer of the overlay. Defaults to z-50.
  // Useful when a modal must appear ABOVE another modal/overlay (e.g.
  // a confirmation that pops over a full-screen editor at z-[100]).
  overlayClassName?: string;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  className,
  overlayClassName
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className={cn('fixed inset-0 flex items-end sm:items-center justify-center', overlayClassName || 'z-50')} data-id="element-2954" data-mp="2k6zx6ijni0rz">
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-2955" data-mp="2i362c340pr9a" />

      <div className={cn('relative w-full sm:max-w-lg max-h-[90vh] bg-[#141414] sm:rounded-2xl rounded-t-2xl shadow-lg flex flex-col anim-slide-up border border-white/10', className)} data-id="element-2956" data-mp="2n20rdmskwc1u">
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10" data-id="element-2957" data-mp="1zdhltf0wyddg">
          {title ? <h2 className="text-lg font-semibold text-white" data-id="element-2958" data-mp="2446dauclfacl">{title}</h2> : <div data-id="element-2959" data-mp="1pfjzix2m6qnh" />}
          <button onClick={onClose} className="p-2 -mr-2 text-white/40 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-2960" data-mp="1pgcwj6bru1sf">
            <X className="w-5 h-5" data-id="element-2961" data-mp="1gdtz51qr8hdk" />
          </button>
        </div>

        <div className="overflow-y-auto p-6" data-id="element-2962" data-mp="1ggpxgr6il82j">{children}</div>
      </div>
    </div>;
}